(function() {
  function initPlanCards(section) {
    var cards = section.querySelectorAll('[data-plan-card]');
    if (!cards.length) return;

    cards.forEach(function(card) {
      var tiltReady = false;

      /* Wait for scroll-trigger entrance to finish, then enable tilt */
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var order = parseInt(card.style.getPropertyValue('--animation-order')) || 1;
            setTimeout(function() {
              var cls = card.className.match(/m-scroll-trigger|animate--[^\s]+/g);
              if (cls) cls.forEach(function(c) { card.classList.remove(c); });
              card.removeAttribute('data-cascade');
              card.style.cssText = '';
              card.style.opacity = '1';
              tiltReady = true;
            }, order * 150 + 800);
            observer.unobserve(card);
          }
        });
      }, { threshold: 0.1 });

      observer.observe(card);

      card.addEventListener('mousemove', function(e) {
        if (!tiltReady) return;
        /* Kill transition so transform tracks the cursor instantly */
        card.style.transition = 'none';
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = 'translateY(-8px) perspective(800px) rotateY(' + (x * 10) + 'deg) rotateX(' + (-y * 10) + 'deg)';
      });

      card.addEventListener('mouseleave', function() {
        if (!tiltReady) return;
        /* Restore transition so the return-to-flat animates smoothly */
        card.style.transition = '';
        card.style.transform = 'translateY(0) perspective(800px) rotateY(0deg) rotateX(0deg)';
      });
    });
  }

  function initCheckoutButtons(section) {
    section.querySelectorAll('[data-plan-checkout]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var variantId = btn.getAttribute('data-variant-id');
        var sellingPlan = btn.getAttribute('data-selling-plan');
        var body = {
          items: [{
            id: parseInt(variantId),
            quantity: 1,
            selling_plan: parseInt(sellingPlan)
          }]
        };
        btn.style.pointerEvents = 'none';
        btn.style.opacity = '0.6';
        fetch('/cart/clear.js', { method: 'POST' })
          .then(function() {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(body)
            });
          })
          .then(function(res) {
            if (!res.ok) throw new Error('Cart add failed');
            window.location.href = '/checkout';
          })
          .catch(function() {
            btn.style.pointerEvents = '';
            btn.style.opacity = '';
            window.location.href = '/products?variant=' + variantId + '&selling_plan=' + sellingPlan;
          });
      });
    });
  }

  document.querySelectorAll('[data-section-type="choose-your-plan"]').forEach(function(section) {
    initPlanCards(section);
    initCheckoutButtons(section);
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      var section = e.target.querySelector('[data-section-type="choose-your-plan"]');
      if (section) {
        initPlanCards(section);
        initCheckoutButtons(section);
      }
    });
  }
})();
